import { render, staticRenderFns } from "./PageBack.vue?vue&type=template&id=488a3b14&scoped=true"
import script from "./PageBack.vue?vue&type=script&lang=js"
export * from "./PageBack.vue?vue&type=script&lang=js"
import style0 from "./PageBack.vue?vue&type=style&index=0&id=488a3b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a3b14",
  null
  
)

export default component.exports